import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 50 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function OrbTechIO() {
  const { t } = useI18n();
  const ventures = [
    {
      tag: t.orbtech.tagTech,
      name: "Orb Tech",
      body: t.orbtech.bodyTech,
      cta: t.orbtech.ctaTech,
      href: "https://orbtech.ai/",
      testid: "visit-orbtech-button",
    },
    {
      tag: t.orbtech.tagProduct,
      name: "IO",
      body: t.orbtech.bodyIO,
      cta: t.orbtech.ctaIO,
      href: "https://orbtech-io-ai.lovable.app/",
      testid: "visit-io-button",
    },
  ];

  return (
    <section
      id="orbtech"
      className="relative z-10 scroll-mt-24 bg-[#050505] px-6 pt-32 pb-24 sm:pl-[120px] sm:pr-16"
      data-testid="orbtech-section"
    >
      <span className="font-mono-accent text-[11px] uppercase tracking-[0.3em] text-[#a855f7]">
        [ 03 — {t.sections.orbtech} ]
      </span>

      <h2 className="mt-8 max-w-[16ch] font-head text-4xl font-light leading-[1.05] tracking-tight text-white sm:text-6xl">
        {t.orbtech.headA}
        <span className="text-white/40"> {t.orbtech.headB}</span>
      </h2>

      <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {ventures.map((v, i) => (
          <motion.article
            key={v.name}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-70px" }}
            data-testid={`venture-${v.name}`}
            className="group flex flex-col justify-between rounded-2xl border border-white/10 bg-white/[0.03] p-8 transition-colors duration-500 hover:border-white/20 hover:bg-white/[0.05] sm:p-10"
          >
            <div>
              <span className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-white/30">
                {v.tag}
              </span>
              <h3 className="mt-4 font-head text-3xl font-medium tracking-tight text-white sm:text-4xl">
                {v.name}
              </h3>
              <p className="mt-5 font-body text-base leading-relaxed text-white/60">
                {v.body}
              </p>
            </div>

            <a
              href={v.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={v.testid}
              className="mt-10 inline-flex w-fit items-center gap-3 rounded-full bg-[#a855f7] px-6 py-3 font-mono-accent text-[11px] uppercase tracking-[0.2em] text-white transition-[background-color,transform] duration-300 hover:bg-[#9333ea] active:scale-[0.97]"
            >
              {v.cta}
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
